import { reduce } from "et3-type-guards";
import i18n from "../../../../constants/i18n";
import getKhattabatMatchingStore from "../../../../stores/khattabat-stores/matching-store";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const MatchesFoundCount = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitY } = theme;
  const resultsNumber = reduce(
    () => getKhattabatMatchingStore().matchesIds.get().length,
    0
  );

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={1510}
      height={80}
      color={""}
      style={{}}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={28}
        isSpan={true}
        text={`${i18n.get("RESULTS_NUMBER")}:`}
        style={{
          height: 50 * unitY,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
        color={""}
      />
      <Et3Margin top={0} bottom={0} left={10} right={0} />
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={28}
        isSpan={true}
        text={`${resultsNumber}`}
        style={{
          height: 50 * unitY,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: colors.all.red
        }}
        color={""}
      />
    </ET3Div>
  );
});

export default MatchesFoundCount;
